import { render, staticRenderFns } from "./Account-add-or-update.vue?vue&type=template&id=d6354e20&scoped=true&"
import script from "./Account-add-or-update.vue?vue&type=script&lang=js&"
export * from "./Account-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6354e20",
  null
  
)

export default component.exports